export default theme => ({
  root: {
    height: '100%',
    width: '100%',
    position: 'relative'
  },
  childrenRoot: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  },
  shown: {
    opacity: '1 !important'
  },
  withFade: {
    height: '100%',
    width: '100%'
  },
  topFade: {
    content: '',
    position: 'absolute',
    top: 0,
    left: 0,
    right: '8px',
    height: '30px',
    background: `linear-gradient(to bottom,
                rgba(255, 255, 255, 1) 10%,
                rgba(255, 255, 255, 0.7) 30%,
                rgba(255, 255, 255, 0) 100%,
            )`
  },
  bottomFade: {
    content: '',
    position: 'absolute',
    top: 0,
    left: 0,
    right: '8px',
    height: '30px',
    background: `linear-gradient(to bottom,
                rgba(255, 255, 255, 1) 10%,
                rgba(255, 255, 255, 0.7) 30%,
                rgba(255, 255, 255, 0) 100%,
            )`
  },
  showVerticalOnHover: {
    '&:hover > div:last-child': {
      opacity: '1 !important'
    }
  },
  scrollContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    width: 'auto !important',
    transform: 'none !important'
  },
  scrollButton: {
    position: 'absolute',
    height: '64px',
    top: 0,
    width: '60px',
    zIndex: 4,
    '& svg': {
      height: '18px',
      width: '18px',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      '& path': {
        fill: theme.colors.actionMinor[500]
      }
    }
  },
  buttonRight: {
    background: `linear-gradient(to right, rgba(255, 255, 255, 0), ${theme.colors.primary.white})`,
    right: 0,
    cursor: 'pointer',
    '& svg': {
      right: '-2px'
    }
  },
  buttonLeft: {
    background: `linear-gradient(to left, rgba(255, 255, 255, 0), ${theme.colors.primary.white})`,
    left: 0,
    cursor: 'pointer',
    '& svg': {
      left: '2px'
    }
  }
});